import React from 'react';
import { ListItemText, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import StatusChip from '../../common/StatusChip';
import type { AdmissionEnquiryStatus } from '../../../types/admissions';
import { ENQUIRY_STATUSES } from './enquiryStatuses';

interface Props {
  anchorEl: HTMLElement | null;
  current?: AdmissionEnquiryStatus;
  onClose: () => void;
  onPick: (status: AdmissionEnquiryStatus) => void;
}

/** Move an enquiry along — opened from its status chip. */
const EnquiryStatusMenu: React.FC<Props> = ({ anchorEl, current, onClose, onPick }) => (
  <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onClose} slotProps={{ paper: { sx: { minWidth: 240 } } }}>
    {ENQUIRY_STATUSES.map(s => (
      <MenuItem key={s.value} selected={s.value === current} onClick={() => onPick(s.value)} sx={{ py: 1 }}>
        <ListItemText
          primary={<StatusChip status={{ kind: 'enquiry', value: s.value }} />}
          secondary={<Typography variant="caption" color="text.secondary" component="span">{s.hint}</Typography>}
          primaryTypographyProps={{ component: 'div' }}
        />
        <Stack sx={{ width: 20, ml: 1 }} alignItems="center">
          {s.value === current && <Check fontSize="small" color="primary" />}
        </Stack>
      </MenuItem>
    ))}
  </Menu>
);

export default EnquiryStatusMenu;
